import { Card } from "@/shared/ui/card";
import { Skeleton } from "@/shared/ui/skeleton";

export const IntegrationCardSkeleton = () => {
  return (
    <Card className="bg-card border-border p-6">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
          
          <Skeleton className="h-4 w-64 mb-4" />

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8 mb-4">
            <div>
              <Skeleton className="h-3 w-16 mb-1" />
              <Skeleton className="h-4 w-32" />
            </div>
            <div>
              <Skeleton className="h-3 w-20 mb-1" />
              <Skeleton className="h-4 w-40" />
            </div>
          </div>

          <div className="mt-4">
            <Skeleton className="h-3 w-16 mb-1" />
            <div className="flex flex-wrap gap-1">
              <Skeleton className="h-5 w-20 rounded-full" />
              <Skeleton className="h-5 w-24 rounded-full" />
            </div>
          </div>
        </div>

        <div className="flex gap-2 ml-4">
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-9 w-9 rounded-md" />
        </div>
      </div>
    </Card>
  );
};

